<template>
  <div class="content">
      <el-form :model="commissionForm" ref="commissionForm"  :inline="true">
          <el-form-item prop="userId" v-if="adminShow">
            <el-cascader
              placeholder="公司名"
              ref="myCascader"
              :options="agentTree"
              :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
              :show-all-levels="false"
              clearable
              v-model="commissionForm.userId"
              @change="search"
              filterable
            ></el-cascader>
          </el-form-item>
          <el-form-item>
              <el-date-picker prop="searchTime"
              value-format="yyyy-MM-dd"
              v-model="commissionForm.searchTime"
              type="daterange"
              range-separator="-"
              start-placeholder="支付开始日期"
              end-placeholder="支付结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="withdrawalStatus">
            <el-select
              v-model="commissionForm.withdrawalStatus"
              placeholder="审核状态"
              clearable
            >
              <el-option
              v-for="item in state"
              :key="item.key"
              :label="item.value"
              :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
          </el-form-item>
      </el-form>
      <div class="sum_commission" v-if="checkPermi(['commission:detail:count'])">
        <el-row :gutter="60">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <span>总订单金额：</span><span style="color:#34bfa3">{{countCommissionData.totalRealPayAmount}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <span>总分润金额：</span><span style="color:#34bfa3">{{countCommissionData.totalRebateAmount}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <span>总利润金额：</span><span style="color:#34bfa3">{{countCommissionData.totalRealRebateAmount}}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-table :data="tableData" border v-loading="loading">
        <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="iccid" label="ICCID" align="center" min-width="110px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="subCompanyName" label="下级代理商" min-width="260px" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="orderNum" label="佣金单号" align="center" min-width="110px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="realPayAmount" label="支付金额" align="center"></el-table-column>
        <el-table-column prop="rate" label="分润比例" align="center"></el-table-column>
        <el-table-column prop="createTime" label="支付时间" align="center" min-width="120px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="totalRebateAmount" label="总分润" align="center"></el-table-column>
        <el-table-column prop="realRebateAmount" label="实分润" align="center"></el-table-column>
        <el-table-column prop="withdrawalStatus" label="审核状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.withdrawalStatus == '0'" type="info">未提现</el-tag>
            <el-tag v-else-if="scope.row.withdrawalStatus == '1'">提现中</el-tag>
            <el-tag v-else type="success">提现成功</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="search"
      />
  </div>
</template>
<script>
import { agentTreeList } from "@/api/api.js"; //代理商
import {countCommission,commission} from "@/api/api.js";
export default {
  data() {
    return {
      // 遮罩层
      loading: true,
      state: [
        {
          key: "0",
          value: "未提现"
        },
        {
          key: "1",
          value: "提现中"
        },
        {
          key: "2",
          value: "提现成功"
        }
      ],
      commissionForm:{
          withdrawalStatus:undefined,
          searchTime:[]
      },
      countCommissionData:{
          totalRealPayAmount:0,
          totalRebateAmount:0,
          totalRealRebateAmount:0
      },
      agentTree:[],
      tableData:[],
      page: 1,
      pageSize: 20,
      total: 0,
    };
  },
  computed: {
    adminShow () {
      return this.$store.getters.user.userType =='1'
    }
  },
  methods: {
    //代理商列表
    handleAgentTreeList(){
      agentTreeList().then(res => {
        this.agentTree = res.data.data;
      });
    },
    // 搜索
    search(){
      this.commissionDataMethod();
      if(this.checkPermi(['commission:detail:count'])){
          this.countCommissionWithdrawMethod();
      }
    },
    reset(){
      this.resetForm("commissionForm");
      this.commissionForm.searchTime=[];
      this.search();
    },
    //佣金明细列表
    commissionDataMethod(){
      let params = {
          model: {
            ...this.addDateRange(this.commissionForm, this.commissionForm.searchTime)
          },
          page: this.page,
          pageSize: this.pageSize,
      };
      this.loading = true;
      commission(params).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.loading = false;
        }else{
          this.$message.error("加载时间过长，请重试！");
          this.loading = false;
        }
      });
    },
    //分润明细列表
    countCommissionWithdrawMethod(){
        let params = {
          ...this.addDateRange(this.commissionForm, this.commissionForm.searchTime)
        };
        countCommission(params).then(res=>{
            if(res.data.code==200){
                this.countCommissionData = res.data.data
            }
        });
    },
  },

  mounted() {

  },
  created() {
    this.search();
    if(this.adminShow){
      this.handleAgentTreeList();
    }
  }
};
</script>
<style scoped lang="less">
.content{
  background-color: #f0f2f5;
}
.el-row {
    // margin-bottom: 20px;
    margin-top:20px ;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple {
    background: #fff;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
    text-align: center;
    line-height: 36px;
    font-size: 16px;
  }
  
</style>


